const getLanguage = ({ langState }) =>
  langState.language;

export {
  getLanguage
};
